import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { isMobile } from "react-device-detect";
import ocesha_logo from "../../assets/ocesha_images/ocesha_logo.png";
import GBALogo from '../../assets/traffic_monster/GBA_Logo.png';
import { useLocation } from "react-router-dom";
import axios from "axios";


const Header = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const apiUrl = process.env.REACT_APP_SERVER_ENDPOINT || "";
  const [GBAUserLogo, setGBAUserLogo] = useState<any>();

  const path = location.pathname;


  const partnerName = location.pathname.split("/").filter(Boolean).pop();

  const hasValidSubscription = (subscriptionLevel: any) => {
    return (
      subscriptionLevel !== undefined &&
      subscriptionLevel !== null &&
      subscriptionLevel !== ""
    );
  };

  const isLoggedIn = localStorage.getItem("logged_in") === "true";

  const getPartnerDetails = async () => {
    try {

      const response = await axios.get(
        `${apiUrl}/api/users/partners/details`,
        {
          params: {
            partner_name: (localStorage.getItem("partner_name") || partnerName)/* "GPA" */,
          },
        }
      );

      if (
        response.data?.status === "success" &&
        response.data?.data
      ) {
        const data = response.data.data;
        setGBAUserLogo(data.logo_url);
      }
    } catch (err) {
      console.log("Partner details not found", err);
    }
  };

  useEffect(() => {
    if ((localStorage.getItem("partner_name") /* === "GPA" */ || partnerName /* === 'GBA' */)) {
      getPartnerDetails();
    }
  }, []);

  useEffect(() => {
    const handler = (e: any) => {
      setGBAUserLogo(e.detail.logo);
    };

    window.addEventListener("partner-logo-updated", handler);

    return () => {
      window.removeEventListener("partner-logo-updated", handler);
    };
  }, []);

  return (
    <div className="container-fluid px-4">
      <div className="row">
        <nav className="navbar navbar-expand-md">
          <div className="container-fluid d-flex justify-content-between align-items-center">
            {/* LOGO */}
            {/* <div
              className="navbar-brand m-0"
              style={{ width: "80px", cursor: "pointer" }}
              onClick={() => (window.location.href = "https://ocesha.ai")}
            >
              <img
                src={ocesha_logo}
                className="img-fluid"
                alt="Ocesha Logo"
                style={{ width: "100%" }}
              />
              {localStorage.getItem('partner_name') === 'GPA'&& (<img
                src={GBALogo}
                className="img-fluid"
                alt="GBA Logo"
                style={{ width: "100%", marginLeft: '16px', height: '100px' }}
              />)}
            </div> */}
            <div
              className="navbar-brand m-0 d-flex align-items-center"
              style={{ cursor: "pointer" }}
              onClick={() => (window.location.href = process.env.REACT_APP_LOGOUT_DOMAIN || '')}
            >
              <div style={{ width: "80px" }}>
                <img
                  src={ocesha_logo}
                  alt="Ocesha Logo"
                  style={{ width: "100%" }}
                />
              </div>

              {((localStorage.getItem("partner_name") /* === "GPA" */ || partnerName /* === 'GBA' */) && GBAUserLogo) && (
                <img
                  src={GBAUserLogo}
                  alt="GBA Logo"
                  style={{
                    // width: "200px",
                    height: "100px",
                    marginLeft: (path === '/codegenie/courses-directory' || path === '/codegenie/courses-directory/GBA') ? "100px" : "140px",
                  }}
                />
              )}
            </div>

            {/* RIGHT BUTTONS */}
            <div
              className="d-flex gap-3"
              style={{
                justifyContent: isMobile ? "center" : "flex-end",
              }}
            >
              {/* SIGN IN */}
              {!isLoggedIn && (<button
                className="btn btn-outline-primary px-4"
                onClick={() => {
                  const isLoggedIn =
                    localStorage.getItem("logged_in") === "true";
                  const userRole = localStorage.getItem("userRole");
                  const userEmail = localStorage.getItem("user_email") || "";
                  const subscriptionLevel = localStorage.getItem("subscription_level") || "";

                  if (!isLoggedIn) {
                    navigate("/signin");
                    return;
                  }

                  // Redirect to pricing if no subscription
                  if (!hasValidSubscription(subscriptionLevel) && userRole === "user") {
                    navigate("/pricing");
                    return;
                  }

                  if (userRole === "user") {
                    localStorage.setItem("activeItem", "authority");
                    navigate("/codegenie/generated-blogs");
                  } else if (userRole === "student") {
                    localStorage.setItem("activeItem", "course");
                    navigate("/codegenie/generated-blogs", {
                      state: { userEmail },
                    });
                  } else {
                    navigate("/signin");
                  }
                }}
              >
                Sign In
              </button>)}

              {/* SIGN UP */}
              {!isLoggedIn && (<button
                className="button_leniar px-4"
                onClick={() =>
                  navigate("/signup", {
                    state: { DirectSignup: "true" },
                  })
                }
              >
                Sign Up
              </button>)}
            </div>
          </div>
        </nav>

        <hr className="mt-3" style={{ color: "#9aa0a3" }} />
      </div>
    </div>
  );
};

export default Header;